var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoParking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1,.prefix__cls-3{fill:none}.prefix__cls-3{stroke:#898e9a}.prefix__cls-4{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__pict-park",
    transform: "translate(-12 -11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_359",
    width: 48,
    height: 48,
    className: "prefix__cls-1",
    "data-name": "Rectangle 359",
    rx: 2,
    transform: "translate(12 11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Groupe_2638",
    "data-name": "Groupe 2638",
    transform: "translate(-5972.294 -14153.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_1535",
    fill: "none",
    stroke: "#898e9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5990.38 14195.52h-4.085v-5.867c0-2.127.853-2.709 2.228-3.123s5.165-1.3 6.285-2.307 5.779-5.631 6.534-6.27a3.431 3.431 0 0 1 2.512-.836h12.635c1.885 0 2.293.229 3.65 1.891l4.884 5.982 5.306 2.473s-.01 5.418 0 6.242-.154 1.783-1.612 1.814-4.775 0-4.775 0",
    "data-name": "Trac\\xE9 1535",
    transform: "translate(0 -.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Ligne_110",
    d: "M0 0L11.894 0",
    className: "prefix__cls-3",
    "data-name": "Ligne 110",
    transform: "translate(6001.448 14195.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Ligne_111",
    d: "M44.447 0L0 0",
    className: "prefix__cls-3",
    "data-name": "Ligne 111",
    transform: "translate(5986.423 14199.267)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1202",
    className: "prefix__cls-3",
    "data-name": "Ellipse 1202",
    transform: "translate(5992 14190.58)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    className: "prefix__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    className: "prefix__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1203",
    className: "prefix__cls-3",
    "data-name": "Ellipse 1203",
    transform: "translate(6014 14190.58)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    className: "prefix__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    className: "prefix__cls-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoParking);
export default __webpack_public_path__ + "static/media/picto-parking.878b91616b4f471f8f1baad820147eeb.svg";
export { ForwardRef as ReactComponent };